export const FreeShipMethodID = "16";
export const DefaultShipMethodID = "1";
export const FlatRateShipMethodID = "";
export const FreeEnrollmentItemID = "";
export const FreeEnrollmentZeroPriceItemID = "";
export const DefaultCountry = "US";
export const DefaultRegionID = "7E2F08E18C";

// Payment Method Merchant IDs
export const EWALLET_MERCHANT_ID = 11;
export const CVV_REQUIRED_MERCHANT_IDS = '99'; // Comma-separated list of merchant IDs that require CVV

// Store IDs - These will be dynamically assigned based on API response
export let REWARDSTORE = "07E1082984";
export let MEMBERSTORE = "CE4A55BCFA";
export let MARKETPLACESTORE = "CE4A55BCFA"; // Same as MEMBERSTORE
export let ENROLLMENTSTORE = "70DC6BB417";
export let MAINSTORE = "823C3C3A16";
export let AUTOSHIPSTORE = "5";

// Legacy constants for backward compatibility (deprecated)
export let CORPORATESTOREID = REWARDSTORE;
export let RETAILSTOREID = MAINSTORE;
export let IBOSTOREID = ENROLLMENTSTORE;
export let AUTOSHIPSTOREID = MEMBERSTORE;

// Interface for store data from API
export interface StoreData {
    ID: string;
    Description: string;
    DisplayName: string;
}

// Function to dynamically assign store IDs based on API response
export function updateStoreConstants(stores: StoreData[]): void {
    stores.forEach(store => {
        const description = store.Description.toLowerCase();
        const displayName = store.DisplayName.toLowerCase();
        
        if (description.includes('reward') || displayName.includes('reward')) {
            REWARDSTORE = store.ID;
            CORPORATESTOREID = store.ID;
        } else if (description.includes('member') || displayName.includes('member')) {
            MEMBERSTORE = store.ID;
            MARKETPLACESTORE = store.ID;
            AUTOSHIPSTOREID = store.ID;
        } else if (description.includes('enroll') || displayName.includes('enroll')) {
            ENROLLMENTSTORE = store.ID;
            IBOSTOREID = store.ID;
        } else if (description.includes('main') || displayName.includes('main')) {
            MAINSTORE = store.ID;
            RETAILSTOREID = store.ID;
        } else if (description.includes('autoship') || displayName.includes('autoship')) {
            AUTOSHIPSTORE = store.ID;
        }
    });
    
    // Set fallbacks for missing stores
    if (!REWARDSTORE && MEMBERSTORE) {
        REWARDSTORE = MEMBERSTORE;
        CORPORATESTOREID = MEMBERSTORE;
    }
}

export function getCurrentStoreConstants() {
    return {
        REWARDSTORE,
        MEMBERSTORE,
        MARKETPLACESTORE,
        ENROLLMENTSTORE,
        MAINSTORE,
        AUTOSHIPSTORE,
        CORPORATESTOREID,
        RETAILSTOREID,
        IBOSTOREID,
        AUTOSHIPSTOREID
    };
}